
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-fdb37fb2\",\"scoped\":true,\"hasInlineConfig\":false}!scss-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./activityDetail.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./activityDetail.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-fdb37fb2\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./activityDetail.vue"),
  /* scopeId */
  "data-v-fdb37fb2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue/views/activity/activityDetail.vue
// module id = 263
// module chunks = 0